import React, { useState } from 'react';
import styled from 'styled-components';
import apiClient from '../../api';
import { Button } from '../../components/common/Button';
import { FormGroup, Label, Input, Message, Select } from '../../components/common/Forms'; // Assumindo que você tem ou criará um Select styled
import { AuthPageContainer, AuthFormCard, Title } from '../../components/common/AuthLayout';
import Header from '../../components/layout/Header';

// Caso não tenha um componente Select pronto em common/Forms:
const StyledSelect = styled.select`
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
  background-color: white;
  font-size: 16px;
  margin-top: 5px;
  &:focus { outline: none; border-color: #EB6C35; }
`;

const AdminInvitePage = () => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  // Estado para o plano selecionado (default: sonda ou vazio)
  const [planCode, setPlanCode] = useState('sonda'); 
  
  const [mensagem, setMensagem] = useState({ text: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMensagem({ text: '', type: '' });

    try {
      const response = await apiClient.post('/api/admin/convidar-cliente', {
        nome,
        email,
        plan_code: planCode, // Envia o código do plano
      });

      setMensagem({ text: response.data.message, type: 'success' });
      // Limpar campos, mas manter um plano padrão selecionado
      setNome('');
      setEmail('');
      setPlanCode('sonda'); 
    } catch (error) {
      setMensagem({
        text: error.response?.data?.error || 'Erro ao enviar convite.',
        type: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header /> 
      <AuthPageContainer>
        <AuthFormCard>
          <Title>Convidar Novo Cliente</Title>
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Label htmlFor="nome">Nome do Contato Principal</Label>
              <Input
                id="nome"
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
                placeholder="Ex: João Silva"
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="email">Email do Contato</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Ex: cliente@empresa.com"
              />
            </FormGroup>

            {/* SELETOR DE PLANOS */}
            <FormGroup>
              <Label htmlFor="plan">Plano Contratado</Label>
              <StyledSelect
                id="plan"
                value={planCode}
                onChange={(e) => setPlanCode(e.target.value)}
                required
              >
                <option value="sonda">Sonda (R$ 149)</option>
                <option value="radar">Radar (R$ 349)</option>
                <option value="observatorio">Observatório (R$ 799)</option>
                <option value="enterprise">Enterprise (Sob Consulta)</option>
              </StyledSelect>
            </FormGroup>

            <Button type="submit" style={{ width: '100%', marginTop: '1rem' }} disabled={isLoading}>
              {isLoading ? 'Processando...' : 'Enviar Convite e Criar Assinatura'}
            </Button>
          </form>

          {mensagem.text && (
            <Message type={mensagem.type} style={{marginTop: '1rem'}}>{mensagem.text}</Message>
          )}
        </AuthFormCard>
      </AuthPageContainer>
    </>
  );
};

export default AdminInvitePage;